var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("el-card", [
    _c("div", { staticClass: "disp-flex mb-5" }, [
      _c(
        "div",
        [
          _c("el-button", { attrs: { type: "text" } }, [
            _c("b", [_vm._v(_vm._s(_vm.$tc(_vm.item.message_code)))])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ml-auto" },
        [
          _vm.item.status && _vm.item.status === "CANCELED"
            ? _c("el-tag", { attrs: { size: "mini", type: "danger" } }, [
                _vm._v(_vm._s(_vm.$translate.action_status(_vm.item.status)))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.status && _vm.item.status === "DONE"
            ? _c("el-tag", { attrs: { size: "mini", type: "success" } }, [
                _vm._v(_vm._s(_vm.$translate.action_status(_vm.item.status)))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.status && _vm.item.status === "PROCESSING"
            ? _c("el-tag", { attrs: { size: "mini", type: "warning" } }, [
                _vm._v(_vm._s(_vm.$translate.action_status(_vm.item.status)))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.status && _vm.item.status === "FAILED"
            ? _c("el-tag", { attrs: { size: "mini", type: "danger" } }, [
                _vm._v(_vm._s(_vm.$translate.action_status(_vm.item.status)))
              ])
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "div",
          { staticClass: "mb-10" },
          [
            _c(
              "div",
              { staticClass: "mb-5", staticStyle: { color: "#303133" } },
              [
                _c("svg-icon", { attrs: { "icon-class": "user" } }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.item.person_by_reference &&
                        _vm.item.person_by_reference.username
                        ? _vm.item.person_by_reference.username
                        : _vm.$t("system")
                    )
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm.item.category
              ? _c(
                  "div",
                  { staticClass: "mb-5", staticStyle: { color: "#303133" } },
                  [
                    _c("p", [_vm._v(" " + _vm._s(_vm.$t("category")) + " ")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.item.category))])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.editMode
              ? _c(
                  "span",
                  { staticStyle: { color: "rgb(115, 115, 115) !important" } },
                  [
                    _vm.item.metadata && !_vm.expanded
                      ? [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm._f("excerpt")(_vm.item.metadata.note)
                              ) +
                              "\n\t\t\t\t"
                          )
                        ]
                      : _vm.item.metadata
                      ? [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.item.metadata.note) +
                              "\n\t\t\t\t"
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.metadata &&
                    _vm.item.metadata.note.length > 300 &&
                    !_vm.expanded
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mt-5 hover-underline cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.handleShowAll()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("readMore")) + "...")]
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.expanded
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mt-5 hover-underline cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.handleShowLess()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("readLess")) + "...")]
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.note_by_reference.original_note
                      ? [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  _vm.item.note_by_reference.original_note,
                                placement: "top"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "hover-underline cursor-pointer"
                                },
                                [_vm._v("(" + _vm._s(_vm.$t("edited")) + ")")]
                              )
                            ]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.editMode && _vm.loggedInUser.reference === _vm.item.created_by
              ? [
                  _c(
                    "div",
                    { staticClass: "mt-5" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function($event) {
                              return _vm.handleEditNote()
                            }
                          }
                        },
                        [
                          _c("svg-icon", { attrs: { "icon-class": "edit" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("edit")))])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.editMode
              ? [
                  _c(
                    "div",
                    { staticClass: "mt-5" },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.item.metadata.note,
                          callback: function($$v) {
                            _vm.$set(_vm.item.metadata, "note", $$v)
                          },
                          expression: "item.metadata.note"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-5" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function($event) {
                              return _vm.handleSaveNote()
                            }
                          }
                        },
                        [
                          _c("svg-icon", { attrs: { "icon-class": "save" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("save")))])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function($event) {
                              return _vm.handleCancelEditNote()
                            }
                          }
                        },
                        [
                          _c("svg-icon", { attrs: { "icon-class": "cancel" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("cancel")))])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.item.note_by_reference &&
        _vm.item.note_by_reference.note_invoices &&
        _vm.item.note_by_reference.note_invoices.length >= 1
          ? [
              _c("div", { staticClass: "mb-5" }, [
                _c("span", [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.$t("regardsTo")) +
                      "\n\t\t\t\t\t" +
                      _vm._s(
                        _vm.$tc(
                          "invoiceWithTotal",
                          _vm.item.note_by_reference.note_invoices.length,
                          {
                            value:
                              _vm.item.note_by_reference.note_invoices.length
                          }
                        )
                      ) +
                      "\n\t\t\t\t"
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.item.note_by_reference.note_invoices, function(
                action_invoice
              ) {
                return _c(
                  "el-tag",
                  {
                    key: action_invoice.invoice_by_reference.reference,
                    staticClass: "cursor-pointer mr-5 mb-5",
                    attrs: { size: "mini" },
                    on: {
                      click: function($event) {
                        return _vm.handleInvoiceClick(
                          action_invoice.invoice_by_reference.reference
                        )
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "hover-underline" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            action_invoice.invoice_by_reference.invoice_number
                          ) +
                          "\n\t\t\t\t"
                      )
                    ])
                  ]
                )
              })
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }